import {
  POSITIONCHANGE_LOADING,
  GET_POSITIONCHANGE,
  GET_POSITIONCHANGE_SUCCESS,
  GET_POSITIONCHANGE_FAIL,
  ADD_POSITIONCHANGE_SUCCESS,
  ADD_POSITIONCHANGE_FAIL,
  DELETE_POSITIONCHANGE_SUCCESS,
  DELETE_POSITIONCHANGE_FAIL,
  UPDATE_POSITIONCHANGE_SUCCESS,
  UPDATE_POSITIONCHANGE_FAIL,
  POSITIONCHANGE_RESET
} from "./actionType";

const INIT_STATE = {
  positionChanges: [],
  error: {},
};

const PositionChange = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_POSITIONCHANGE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_POSITIONCHANGE:
          return {
            ...state,
            positionChanges: action.payload.data,
            isPositionChangeCreated: false,
            isPositionChangeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_POSITIONCHANGE_FAIL:
      switch (action.payload.actionType) {
        case GET_POSITIONCHANGE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPositionChangeCreated: false,
            isPositionChangeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_POSITIONCHANGE: {
      return {
        ...state,
        isPositionChangeCreated: false,
        loading: true,
      };
    }

    case POSITIONCHANGE_LOADING: {
      return {
        ...state,
        isPositionChangeCreated: false,
        loading: true,
      };
    }

    case ADD_POSITIONCHANGE_SUCCESS:
      return {
        ...state,
        isPositionChangeCreated: true,
        loading: false,
        positionChanges: [action.payload.data, ...state.positionChanges],
      };

    case ADD_POSITIONCHANGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_POSITIONCHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        positionChanges: state.positionChanges.filter(
          positionChange => positionChange.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_POSITIONCHANGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_POSITIONCHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        positionChanges: state.positionChanges.map(positionChange =>
          positionChange.id.toString() === action.payload.data.id.toString() ? { ...positionChange, ...action.payload.data } : positionChange
        ),
      };

    case UPDATE_POSITIONCHANGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case POSITIONCHANGE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PositionChange;